import { useState, useEffect, useCallback } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { howlerAudio } from '../utils/howlerAudio';

interface VolumeControlProps {
  className?: string;
}

export function VolumeControl({ className = '' }: VolumeControlProps) {
  const [volume, setVolume] = useState(() => howlerAudio.getVolume());
  const [isMuted, setIsMuted] = useState(() => howlerAudio.isMuted());
  
  // Update Howler when volume changes
  useEffect(() => {
    howlerAudio.setVolume(volume);
  }, [volume]);
  
  // Update Howler when mute state changes
  useEffect(() => {
    howlerAudio.setMuted(isMuted);
  }, [isMuted]);
  
  // Toggle mute state
  const toggleMute = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);
  
  // Handle volume change from slider
  const handleVolumeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
  }, []);
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        onClick={toggleMute}
        className="flex h-8 w-8 items-center justify-center rounded bg-gray-800 text-gray-400 hover:bg-gray-700"
        aria-label={isMuted ? 'Unmute' : 'Mute'}
      >
        {isMuted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={volume}
        onChange={handleVolumeChange}
        className="h-2 w-24 appearance-none rounded-lg bg-gray-700"
        disabled={isMuted}
      />
      
      <span className="text-xs text-gray-400">
        {Math.round(volume * 100)}%
      </span>
    </div>
  );
} 